<template src="./Details.html">
</template>

<script>
export default {
        props: {
            itemId: {
                type: Number,
                required: true,
            },
        },

        created() {
            this.$store
                .dispatch("jobs/getDetails", this.itemId)
                .then(() => {

                })
                .catch(() => { });
        },
  computed: {
      job() {
          return this.$store.state.jobs.job;
      }
  },
};
</script>